import { useLocationStore } from '@/entities/location/store/location';
import { useCategoriesStore } from '@/entities/category/store/category';
import {
  FIND_LAWYER_CITIES_LIMIT,
  buildFindLawyerCategoryItems,
  buildFindLawyerCityItems,
  filterItemsByName,
} from '@/pages/main/lib/findLawyerItems';
import type { Item } from '@/shared/ui/ColumnsBlock/model/types/columnsBlock';
import type { Option } from '@/shared/ui/AppSelect/model/types/appSelect';
import type { Tab } from '@/shared/ui/AppTabs/model/types/appTabs';

export const useFindLawyer = () => {
  const locationStore = useLocationStore();
  const categoriesStore = useCategoriesStore();
  const { cities } = storeToRefs(locationStore);
  const { categories } = storeToRefs(categoriesStore);

  const tabList: Tab[] = [
    { id: 1, label: 'По специализации', value: 'specialization' },
    { id: 2, label: 'По городу', value: 'city' },
  ];
  const activeTab: Ref<string | number> = ref('specialization');

  const categoryItems: ComputedRef<Item[]> = computed(() =>
    buildFindLawyerCategoryItems(categories.value),
  );
  const cityItems: ComputedRef<Item[]> = computed(() =>
    buildFindLawyerCityItems(cities.value),
  );

  const categoryColumnsItems: ComputedRef<Item[]> = computed(() => categoryItems.value);
  const cityColumnsItems: ComputedRef<Item[]> = computed(() =>
    buildFindLawyerCityItems(cities.value.slice(0, FIND_LAWYER_CITIES_LIMIT)),
  );

  const categoryQuery: Ref<string> = ref('');
  const cityQuery: Ref<string> = ref('');

  const toSelectOptions = (items: Item[]): Option[] =>
    items.map(({ id, name, link }) => ({ id, name, link }));

  const filteredCategoryItems: ComputedRef<Option[]> = computed(() =>
    toSelectOptions(filterItemsByName(categoryItems.value, categoryQuery.value)),
  );
  const filteredCityItems: ComputedRef<Option[]> = computed(() =>
    toSelectOptions(filterItemsByName(cityItems.value, cityQuery.value)),
  );

  const searchCategories = (value: string): void => {
    categoryQuery.value = value;
  };

  const searchCities = (value: string): void => {
    cityQuery.value = value;
  };

  return {
    tabList,
    activeTab,
    categoryColumnsItems,
    cityColumnsItems,
    filteredCategoryItems,
    filteredCityItems,
    searchCategories,
    searchCities,
  };
};

export default useFindLawyer;
